import { ModalContainerService } from "@aecom/core";
import { Component, Input, inject } from "@angular/core";

@Component({
  selector: "app-readRecall-modal",
  templateUrl: "./readRecall-modal.component.html",
  styleUrls: ["./readRecall-modal.component.css"],
  standalone: false
})
export class ReadRecallModalComponent {
  private activeModal = inject(ModalContainerService);

  @Input() title = "";
  @Input() body = "";

  save() {
    this.activeModal.close(1);
  }
}
